import React, { Component } from "react";
import { Link } from "react-router-dom";
import { decode as base64_decode, encode as base64_encode } from "base-64";

import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import HelpModal from "./HelpModal";
import { Layout, Button, Row, Col, Card, Divider, Image } from "antd";
import Cookies from "universal-cookie";
import conf from "../config";
import L from "leaflet";
import SecureTrackVehicleStore from "../store/SecureTrackVehicleStore";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import MarkerClusterGroup from "react-leaflet-cluster";
import {
  MapContainer,
  TileLayer,
  Popup,
  Circle,
  Polygon,
  Tooltip as MapTooltip,
  FeatureGroup,
  ZoomControl,
  Polyline,
  Marker,
} from "react-leaflet";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
const { Header, Content } = Layout;
// const { Title } = Typography;
const firstIcon = L.divIcon({
  className: "dot-icon",
  iconSize: [20, 35], // Adjusted the iconSize to match the image dimensions
  html: `<img src="${require("../assets/images/location-pin.png")}" width="20px" height="35px" />`,
});

class SecureTrackLaunchingDashboard extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.SecureTrackVehicleStore = new SecureTrackVehicleStore(this);

    this.state = {};
    this.showLaunchingItems = {
      livetracking: false,
      dashboard: false,
      historytracking: false,
      detailtracking: false,
      parentalertreportlist: false,
      master: false,
      AdvanceDashboard: false,
      vehiclelist: false,
      parentreport: false,
      maintenancedashboard: false,
      showHelpModal: false,
      showLaunchingDashboard: 2,
      vehicleDataArr: [],
    };

    this.mapRef = React.createRef();
    this.updateDashboard(2);
    let cookies = this.cookies.get("data");
    //this.rolePermission = JSON.parse(base64_decode(cookies)).rolePermission;
    this.rolePermission = JSON.parse(localStorage.getItem("rolePermission"));

    console.log(JSON.parse(base64_decode(cookies)).rolePermission);
    if (JSON.parse(base64_decode(cookies)).logo) {
      this.state.logo = JSON.parse(base64_decode(cookies)).logo;
      console.log(this.state.logo);
    }
    console.log(this.rolePermission);
    if (this.rolePermission !== "All") {
      this.roleSettingForUser();
    }
    for (let i in this.showLaunchingItems) {
      if (this.rolePermission?.includes(i) || this.rolePermission === "All") {
        this.showLaunchingItems[i] = true;
      }
      // console.log(i);
    }
  }
  roleSettingForUser = () => {
    // Master Section
    let obj = {
      master: {
        parentaccount: [
          "companyList",
          "companyuserlist",
          "companydriverslist",
          "companystafflist",
          "passengerList",
        ],
        vehiclemanagement: [
          "vehiclelist",
          "VehicleAllocateList",
          "vehiclereturnassetlist",
          "vehiclemaintenancelist",
          "VehicleTempSensorList",
          "VehicleGroupList",
          "VehicleWorkingHoursList",
          "vehicledistancelist",
          "VehicleLiveLocationList",
          "VehicleOdometerList",
          "VehicleTrailerList",
          "VehicleFuelCalibrationList",
        ],
        parentfuelmanagement: ["fueldetailslist", "fuelfilledlist"],
        parentschoolmanagement: [
          "passengerList2/1",
          "gradetiminglist",
          "schoolcalenderlist",
          "passengerList",
          "parentlist",
        ],
        parentjobmanagement: ["jobmanagementlist", "jobrequestlist"],
        parenttripmanagement: ["assigntriplist", "tripCostList"],
        parentpayment: ["paymentlist"],
        parentwarehouse: ["warehouselist"],
        parentinventory: ["inventorylist"],
      },

      parentreport: {
        parenttrackingreport: [
          "trackdatalist",
          "travelreportlist",
          "stoppagereportlist",
          "tripreportlist",
          "idlereportlist",
          "exidlereportlist",
          "distancereportlist",
          "commandsendreportlist",
          "canbusreportstorelist",
          "machineryseportlist",
          "stationaryreportlist",
          "weightreportlist",
          "vehicleperformancelist",
          "workinghoursreportlist",
        ],
        parentmiscellaneousreport: [
          "eventreportlist",
          "passengerlogreportlist",
          "attendencereportlist",
          "blacklistpersonreportlist",
        ],
        parentfleetreport: [
          "fleetdaysummaryreport",
          "FleetSummaryReportList",
          "FuelFilledReportList",
          "MileageReportList",
          "MaintenanceFleetReportList",
        ],
        parentalertreport: [
          "SpeedViolationReportList",
          "geofenceinoroutreportlist",
          "TempReportList",
          "GeofenceSummaryList",
          "VehicleNotPollReportList",
          "RuleTriggerList",
          "GeofenceVisitReportList",
          "mdvralarmreportlist",
        ],
        parentadminreport: [
          "userloginreportlist",
          "assetregisterreportlist",
          "commandsendreportlist",
          "rawdatareportlist",
          "useractivityreportlist",
        ],
        parentreport: [
          "waslreportlist",
          "waslbustripresponselist",
          "inventorystatusrepostlist",
          "parentwaslreport",
        ],
        parentdriverreport: [
          "driverscorereportlist",
          "overtimereportlist",
          "DriverLoginReportList",
          "DriverPerformanceReportList",
          "DriverComplainReportList",
        ],
      },
    };
    this.compareSubArrays(obj);
    //Tracking Section
    let parenttracking = [
      "livetracking",
      "detailtracking",
      "trackbygroup",
      "dashboard",
      "maintenancedashboard",
      "multitracking",
      "liveroutepath",
      "historytracking",
      "AdvanceDashboard",
      "sensorreportlist",
      "warehousemonitoring",
      "temperaturedashboard",
      "heatmap",
      "videomonitoring",
      "multivideomonitoring",
      "parenttracking",
    ];
    this.compareSubArrays(parenttracking, "parenttracking");
    //setting section
    let parentsettings = [
      "notificationlist",
      "simlist",
      "deviceloglist",
      "inspectionlist",
      "gprscommand",
      "emailmessage",
      "devicelist",
      "companychangepassword",
      "companymenusetting",
      "companydevicetestinglist",
      "companydriverbehaviorsetting",
      "geofencereportlist",
      "logout",
      "parentsettings",
    ];
    this.compareSubArrays(parentsettings, "parentsettings");
    // graph section
    let parentgraph = [
      "SpeedGraph",
      "DistanceGraph",
      "IdleGraph",
      "ExIdleGraph",
      "UsageGraph",
      "TempGraph",
      "DashboardGraph",
      "FuelGraph",
      "DriverScoreGraph",
      "MaxSpeedGraph",
      "parentgraph",
    ];
    this.compareSubArrays(parentgraph, "parentgraph");
  };

  compareSubArrays = async (obj, parent) => {
    if (parent) {
      if (this.rolePermission?.some((item) => obj?.includes(item))) {
        !this.rolePermission.includes(parent) &&
          this.rolePermission.push(parent);
      }
    } else {
      for (let x in obj) {
        let dataObj;
        if (x === "master") {
          dataObj = obj.master;
          for (let y in dataObj) {
            dataObj[y]?.forEach((val) => {
              if (
                this.rolePermission.includes(val) &&
                !this.rolePermission.includes(y)
              ) {
                this.rolePermission.push(y);
                !this.rolePermission.includes(x) && this.rolePermission.push(x);
              }
            });
          }
        }
        if (x === "parentreport") {
          dataObj = obj.parentreport;

          for (let y in dataObj) {
            console.log(this.rolePermission);
            console.log(dataObj);
            dataObj[y].map((val) => {
              if (
                this.rolePermission.includes(val) &&
                !this.rolePermission.includes(y)
              ) {
                this.rolePermission.push(y);
                !this.rolePermission.includes(x) && this.rolePermission.push(x);
              }
            });
          }
        }
      }
    }
    await this.updateRolepermisson(this.rolePermission);
  };

  updateRolepermisson = (value) => {
    const encodedCookieData = this.cookies.get("data");
    const decodedCookieData = JSON.parse(base64_decode(encodedCookieData));
    console.log(value);
    decodedCookieData.rolePermission = value;
    console.log(decodedCookieData, "decoded cookidata");
    const updatedEncodedCookieData = base64_encode(
      JSON.stringify(decodedCookieData)
    );
    this.cookies.set("data", updatedEncodedCookieData, { path: "/" });
    this.setState({ update: 1 });
  };
  updateDashboard = (value) => {
    const encodedCookieData = this.cookies.get("data");
    const decodedCookieData = JSON.parse(base64_decode(encodedCookieData));
    decodedCookieData.showLaunchingDashboard = value;
    console.log(decodedCookieData, "decoded cookidata");
    const updatedEncodedCookieData = base64_encode(
      JSON.stringify(decodedCookieData)
    );
    this.cookies.set("data", updatedEncodedCookieData, { path: "/" });
    //this.setState({ update: 1 });
  };
  componentDidUpdate(prevProps, prevState) {
    if (this.props.getUserData().userType == 9) {
      this.handleRedirect(0, "/technicianvehiclelist");
    }
    // if (this.mapRef.current) {
    //   this.mapRef.current.setView(
    //    conf.mapCenter,
    //     this.mapRef.current.getZoom()
    //   );
    // }
  }
  async componentDidMount() {
    await this.SecureTrackVehicleStore.loadData({
      userId: this.props.getUserData().userId,
      companyId: this.props.getUserData().userCompanyId,
    });

    this.setState({ update: 1 }, () => {
      // Fit map to vehicle markers after state update
      const vehicles = this.SecureTrackVehicleStore?.vehicles || [];
      const bounds = vehicles
        .filter((v) => v.latitude && v.longitude)
        .map((v) => [v.latitude, v.longitude]);

      if (this.mapRef.current && bounds.length > 0) {
        this.mapRef.current.fitBounds(bounds);
      }
    });
  }

  handleRedirect = (dashboardType, path) => {
    this.updateDashboard(dashboardType);
    this.props.navigate(path);
  };

  getColorClass = (status) => {
    if (!status) return "gray";
    switch (status.toLowerCase()) {
      case "running":
        return "listgreenn";
      case "stopped":
        return "redd";
      case "idle":
        return "blue";
      case "no data":
        return "gray";

      default:
        return "gray";
    }
  };

  rotateIcon = (iconUrl, rotation) => {
    const icon = L.divIcon({
      iconAnchor: [0, 0],
      iconSize: [0, 0],
      // iconAnchor: [10, 20], // Center of the icon
      html: `<img src=${require(`../assets/images/livetracking/${iconUrl}`)} style="transform: rotate(${Number(
        rotation
      )}deg) ;  width: 20px; height: 35px;">`,
    });

    return icon;
  };
  iconCreateFunction = function (cluster) {
    //   console.log('innn')
    //console.log(cluster._markers[0].options.currentStatus);
    const markers1 = cluster._markers;
    var idle = 0;
    var stopped = 0;
    var running = 0;
    var nodata = 0;
    var indexA = "";
    var clusterIconType = [];

    const markers = cluster.getAllChildMarkers();

    Object.keys(markers).map((e, i) => {
      var currentStatus = markers[i].options.currentStatus;

      var lastReportingTime = markers[i].options.options.obj?.updatedate;
      var serverCurrentTime = markers[i].options.options.obj?.currtime;

      var acc = markers[i].options.options.obj?.acc;
      var speed = markers[i].options.options.obj?.speed;

      var diff = new Date(serverCurrentTime) - new Date(lastReportingTime);

      diff /= 60000; //diff convert in minutes.

      if (diff >= 90) {
        if (!clusterIconType.includes(1)) {
          clusterIconType.push(1);
        }
      } else if (acc == 1 && speed == 0) {
        //idle
        if (!clusterIconType.includes(2)) {
          clusterIconType.push(2);
        }
      } else if (acc == 0 || speed == null) {
        //stopped
        if (!clusterIconType.includes(3)) {
          clusterIconType.push(3);
        }
      } else if (acc == 1 && speed > 0) {
        //running
        if (!clusterIconType.includes(4)) {
          clusterIconType.push(4);
        }
      }
      // if (currentStatus == "idle") {
      //   idle++;
      // }
      // if (currentStatus == "stopped") {
      //   stopped++;
      // }
      // if (currentStatus == "running") {
      //   running++;
      // }
      // if (currentStatus == "nodata") {
      //   nodata = nodata + 1;
      // }
    });

    switch (parseInt(clusterIconType.sort().join(""))) {
      case 1:
        indexA = 1;
        break;
      case 2:
        indexA = 2;
        break;
      case 3:
        indexA = 3;
        break;
      case 4:
        indexA = 4;
        break;
      case 12:
        indexA = 5;
        break;
      case 13:
        indexA = 6;
        break;
      case 14:
        indexA = 7;
        break;
      case 23:
        indexA = 8;
        break;
      case 24:
        indexA = 9;
        break;
      case 34:
        indexA = 10;
        break;
      case 123:
        indexA = 11;
        break;
      case 124:
        indexA = 12;
        break;
      case 134:
        indexA = 13;
        break;
      case 234:
        indexA = 14;
        break;
      case 1234:
        indexA = 15;
        break;

      default:
        indexA = 1;
        break;
    }

    var imagename = indexA + ".png";

    const imageUrl = require("../assets/images/clusterMarkers/" + imagename);
    return L.divIcon({
      html: `<div style="border-radius: 50%;  width: 40px; height: 40px;position: relative;text-align:center"><img src="${imageUrl}" /><span style="color: black;position: absolute;left: 0;right: 0;
              line-height: 36px;">${cluster.getChildCount()}</span></div>`,
      className: "marker-cluster-custom",
      iconSize: [40, 40],
    });
  };

  render() {
    const formItemStyle = { marginBottom: "2px", marginTop: "2px" };
    console.log("Vehicles in render:", this.SecureTrackVehicleStore?.vehicles);
    return (
      <div className="dashboard-container">
        <img
          src={require("../assets/images/St-Launching-dashboard.jpg")}
          alt="Dashboard Background"
          className="dashboard-bg"
        />

        <div className="steering-section">
          <div className="steering">
            <div className="circle-button-wrapper">
              <div
                className="circle-button"
                onClick={() => {
                  if (this.showLaunchingItems["dashboard"]) {
                    this.handleRedirect(0, "/dashboard");
                  }
                }}
                style={{ cursor: "pointer" }}
              ></div>
            </div>
            <div className="circle-button-wrapper">
              <div
                className="circle-button"
                onClick={() => {
                  if (this.showLaunchingItems["master"]) {
                    if (Number(this.props.getUserData().isadmin) === 0) {
                      this.handleRedirect(0, "/companyuserlist");
                    } else {
                      this.handleRedirect(0, "/companylist");
                    }
                  }
                }}
                style={{ cursor: "pointer" }}
              ></div>
            </div>
          </div>
        </div>

        <div className="top-panel">
          <Button
            className="panel-btn"
            onClick={() => {
              if (this.showLaunchingItems["parentreport"]) {
                this.handleRedirect(0, "/trackdatalist");
              }
            }}
          >
            REPORTS
          </Button>
          <Button
            className="panel-btn"
            onClick={() => {
              if (this.showLaunchingItems["vehiclelist"]) {
                this.handleRedirect(0, "/vehiclelist/4");
              }
            }}
          >
            EXPIRING SOON
          </Button>
          <Button
            className="panel-btn"
            onClick={() => {
              if (this.showLaunchingItems["detailtracking"]) {
                this.handleRedirect(0, "/detailtracking");
              }
            }}
          >
            DETAIL<br></br>TRACKING
          </Button>
          <div className="panelbtn-2 d-flex gap-2 flex-column">
            <Button
              className="panel-btn"
              onClick={() => {
                this.setState({ showHelpModal: true });
              }}
            >
              HELP
            </Button>
            <Button
              className="panel-btn"
              onClick={() => {
                if (this.showLaunchingItems["parentalertreportlist"]) {
                  this.handleRedirect(0, "/alertlist");
                }
              }}
            >
              ALERT
            </Button>
          </div>
          <Button
            className="panel-btn adv-btn"
            onClick={() => {
              if (this.showLaunchingItems["AdvanceDashboard"]) {
                this.handleRedirect(0, "/AdvanceDashboard");
              }
            }}
          >
            ADVANCED<br></br>DASHBOARD
          </Button>
          <img
            src={require("../assets/images/mapImage.png")}
            alt="Mini Map"
            className="mini-map"
          />
        </div>

        <div className="middle-section">
          <div className="map-section">
            <div className="d-flex">
              <div className="map-panel">
                <MapContainer
                  center={conf.mapCenter}
                  zoom={conf.mapZoom}
                  className="map-image h-100"
                  ref={this.mapRef}
                >
                  {/* <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        /> */}
                  <ReactLeafletGoogleLayer
                    key={this.state.type ? this.state.type : ""}
                    type={this.state.type ? this.state.type : "roadmap"}
                    googleMapsAddLayers={
                      this.state.traffic ? [{ name: "TrafficLayer" }] : null
                    }
                  />
                  <MarkerClusterGroup
                    chunkedLoading
                    iconCreateFunction={this.iconCreateFunction}
                  >
                    {this.SecureTrackVehicleStore?.vehicles?.map((val) => {
                      return (
                        val.latitude &&
                        val.longitude && (
                          <Marker
                            position={[val?.latitude, val?.longitude]}
                            // icon={this.customIcon}
                            icon={this.rotateIcon(val.mapImage, val.direction)}
                            options={{ obj: val }}
                            // onClick={() => this.rowClicked()}
                          >
                            {/* <Popup>{val?.formatted_address} </Popup> */}
                            <Popup direction="top">
                              <b>{this.context.translate("_VEHICLE_NO_")}:</b>{" "}
                              {val?.vehicleNo}
                              <br />
                              <b>
                                {this.context.translate(
                                  "_FLEET_DASHBORD_SHOWGEO_ADDRESS_"
                                )}{" "}
                                :{" "}
                              </b>
                              {val?.formatted_address}
                              <br />
                              <b>
                                {this.context.translate(
                                  "_FLEET_DASHBORD_HISTORY_TOOLTIP_MOBILE_"
                                )}
                                :
                              </b>{" "}
                              {val?.mobileno ? val?.mobileno : ""}
                              <br />
                              <b>{this.context.translate("_NAME_")}: </b>
                              {val?.name}
                            </Popup>
                            <MapTooltip direction="top" permanent>
                              <div
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "10px",
                                }}
                              >
                                {" "}
                                {val?.vehicleNo}
                                {val?.name ? ` / ${val.name}` : ""}
                              </div>
                            </MapTooltip>
                          </Marker>
                        )
                      );
                    })}
                  </MarkerClusterGroup>
                </MapContainer>
              </div>

              {/* <div className="vehicle-list">
         <h4>VEHICLE LIST</h4>
         <ul className="p-0">
           <li className="vehicle-item greenn">X-56987</li>
           <li className="vehicle-item redd">L-55965</li>
           <li className="vehicle-item greenn">X-56987</li>
           <li className="vehicle-item blue">S-96658</li>
           <li className="vehicle-item gray">P-52634</li>
         </ul>
       </div>       */}

              {/* ---------- VEHICLE LIST (dynamic) ---------- */}

              {console.log(
                this.SecureTrackVehicleStore?.vehicles,
                "this.SecureTrackVehicleStore?.vehicles"
              )}
              <div className="vehicle-list">
                <h4>VEHICLE LIST</h4>
                {/* {this.SecureTrackVehicleStore.loading ? (
                  <p>Loading…</p>
                ) :
                 ( */}
                <ul className="p-0">
                  {this.SecureTrackVehicleStore?.vehicles.map((veh, idx) => (
                    <li
                      key={idx}
                      className={`vehicle-item ${this.getColorClass(
                        veh.vehStatus
                      )}`}
                      onClick={() => {
                        this.handleRedirect(
                          0,
                          "/livetracking/" + veh.vehicleId
                        );
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {veh.vehicleNo}
                    </li>
                  ))}
                  {this.SecureTrackVehicleStore?.vehicles?.length === 0 && (
                    <li className="vehicle-item gray">No vehicles found</li>
                  )}
                </ul>
                {/* )}  */}
              </div>
              {/* ---------- end VEHICLE LIST ---------- */}
            </div>
            <div className="map-footer">
              <p>LIVE TRACKING</p>
              <div className="d-flex gap-3">
                <div className="indicatorred"></div>
                <div className="indicatorgreen"></div>
                <div className="indicatorblue"></div>
                <div className="indicatorgrey"></div>
              </div>
            </div>
          </div>

          <div className="side-buttons">
            <Button
              className="side-btn"
              onClick={() => {
                if (this.showLaunchingItems["historytracking"]) {
                  this.handleRedirect(0, "/historytracking");
                }
              }}
            >
              HISTORY <br></br>TRACKING
            </Button>
            <Button
              className="side-btn"
              onClick={() => {
                if (this.showLaunchingItems["maintenancedashboard"]) {
                  this.handleRedirect(0, "/maintenancedashboard");
                }
              }}
            >
              MAINTANANCE <br></br>DASHBOARD
            </Button>
          </div>
        </div>

        <HelpModal
          show={this.state.showHelpModal}
          closeModal={() => this.setState({ showHelpModal: false })}
        />
      </div>
    );
  }
}
SecureTrackLaunchingDashboard.contextType = StoreContext;
export default observer(withRouter(SecureTrackLaunchingDashboard));
